__turbopack_context__.v({
  "blink": "MarkAsReadButton-module-scss-module__UKwiwW__blink",
  "error": "MarkAsReadButton-module-scss-module__UKwiwW__error",
  "icon": "MarkAsReadButton-module-scss-module__UKwiwW__icon",
  "loading": "MarkAsReadButton-module-scss-module__UKwiwW__loading",
  "markAsReadButton": "MarkAsReadButton-module-scss-module__UKwiwW__markAsReadButton",
});
